export default __webpack_public_path__ + "static/media/841c581c6cf31e385fd200b4e32bf6391602465587960.1fbefda2.webp";